import Slider from '../utils/slider'

const NAVIGATION_BUTTON_INACTIVE_CLASS = 'news-list__swiper-controller--inactive'

class NewsListSlider {
  constructor() {
    this.newsListSliders = document.querySelectorAll('.news-list__slider')

    this.newsListSliders.forEach(slider => {
      new Slider({
        parent: slider,
        buttonInactiveClass: NAVIGATION_BUTTON_INACTIVE_CLASS,
      })
    })
  }
}

export default NewsListSlider
